import React from "react";
import "./CSS/Nond.css";

const Donation = () => {
  return (
    <section className="donation-section">
      <div className="donation-content">
        <h2 className="donation-title">देणगी</h2>
        <p className="donation-text">
          उत्सव मंडळ आयोजित विविध समाजोपयोगी उपक्रमाकरिता देणगी स्वरूपात आपले योगदान देऊ शकता
        </p>
        {/* <button className="donation-btn">आत्ता दान करा </button> */}
      </div>
    </section>
  );
};

export default Donation;
